import '../../../styles/global.scss';
import S from './Login.module.scss';

import kakaoLogo from './assets/kakao-logo.svg';
import googleLogo from './assets/google-logo.svg';
import naverLogo from './assets/naver-logo.svg';

import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import { AuthUtils } from '../../../utils/AuthUtils';
import _ from 'lodash';
import { fetchUsersMe } from '../../../repository/LoginRepository';

const Login = () => {
  const ivyApiDomain = process.env.REACT_APP_IVY_APP_SERVER_API_DOMAIN;

  // 이미 로그인 되어있으면 홈으로 redirect
  useEffect(() => {
    const token = AuthUtils.getCookie('token');
    if (!_.isEmpty(token)) {
      fetchUsersMe(token)
        .then((res) => {
          if (res.status === 'NORMAL') {
            location.href = '/';
          }
        })
        .catch((error) => console.error(error));
    }
  }, []);

  return (
    <>
      <main className={S.login_container}>
        <section className="wrapper">
          <div className={S.top_home}>
            <p className="button-s" onClick={() => (location.href = '/')}>
              아이비리거홈
            </p>
          </div>
          <div className={S.logo_wrap}>
            <h1 className={S.logo}>
              <Link to="/login">아이비리거</Link>
            </h1>
            <p className="b3">아이비리거 가입을 환영합니다.</p>
          </div>
          <div className={S.sns_login_wrap}>
            <div
              className={S.sns_btn}
              onClick={(e) => {
                location.href = `${ivyApiDomain}/oauth2/authorization/kakao`;
              }}
            >
              <img src={kakaoLogo} alt="카카오톡 로그인" />
              <p className="button-l">카카오톡으로 로그인</p>
            </div>
            <div
              className={S.sns_btn}
              onClick={() => {
                location.href = `${ivyApiDomain}/oauth2/authorization/google`;
              }}
            >
              <img src={googleLogo} alt="구글 로그인" />
              <p className="button-l">구글로 로그인</p>
            </div>
            {/* 추후 네이버 로그인 연동되면 다시 원복 */}
            {/*<div*/}
            {/*  className={S.sns_btn}*/}
            {/*  onClick={() => {*/}
            {/*    location.href = `${ivyApiDomain}/oauth2/authorization/naver`;*/}
            {/*  }}*/}
            {/*>*/}
            {/*  <img src={naverLogo} alt="네이버 로그인" />*/}
            {/*  <p className="button-l">네이버로 로그인</p>*/}
            {/*</div>*/}
          </div>
        </section>
      </main>
    </>
  );
};

export default Login;
